// src/components/FirstPanel.js

import React, { useState, useContext, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Board from "./board";
import Individual from "./individual";
import Navbar from "./navbar";
import { AuthContext } from "../contexts/AuthContext";
import axios from '../utils/axiosConfig';

const FirstPanel = () => {
  const location = useLocation();
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({
    priority: "",
    startDate: "",
    endDate: "",
    group: "",
    email: ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const backendKey = process.env.REACT_APP_backend_key;
  const myendpoint = process.env.REACT_APP_backend;

  const { auth } = useContext(AuthContext);
  const navigate = useNavigate();

  // Solo se ejecutará si la ruta no es '/individual' y si hay un grupo seleccionado
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const authorizationHeader = {
          headers: {
            Authorization: backendKey,
          },
        };

        const view_id = getViewId(filters.group);
        if (!view_id) {
          setIsLoading(false);
          return;
        }

        const response = await axios.get(
          `${myendpoint}/vista?view_id=${view_id}`,
          authorizationHeader
        );

        const dataWithGroup = response.data.map((item) => ({
          ...item,
          group: filters.group,
        }));

        applyFilters(dataWithGroup, filters);
      } catch (error) {
        setError("Error en la comunicación con el backend");
      } finally {
        setIsLoading(false);
      }
    };

    // Solo ejecuta fetchData si hay un grupo definido y la ruta no es '/individual'
    if (filters.group && location.pathname !== '/individual') {
      fetchData();
    } else {
      setFilteredData([]);
    }
  }, [filters.group, backendKey, myendpoint, location.pathname]); // Agrega 'location.pathname' como dependencia

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const getViewId = (group) => {
    const groupMap = {
      "MDA Aplicaciones N1": 1480,
      "On Site METRO n1": 1482,
      "On Site CAPs N1": 1498,
      "Depósito N1": 1495,
      "Soporte Home CAPs N1": 1497,
      "Laboratorio N1": 1494,
      "Logística N1": 1493,
      "MDA ABM Usuarios N1": 1489,
      "MDA Back Office N1": 1488,
      "MDA CAT/CAD/CGD N1": 1492,
      "MDA VDI N1": 1490,
      "On Site PP Nivel 1": 1481,
      "On Site CAT/CAD/CGD N1": 1484,
      "On Site CRUM N1": 1487,
      "On Site Urgencias 7x24 N1": 1486,
      "Soporte Home CAT/CAD/CGD N1": 1485,
      "Soporte Home PP N1": 1483,
      "Soporte Técnico Online N1": 1491,
      "Verificaciones tecnicas N1": 1496,
    };
    return groupMap[group] || null;
  };

  const applyFilters = (data, filters) => {
    const { priority, startDate, endDate, group, email } = filters;
    const startDateObj = startDate ? new Date(startDate) : null;
    const endDateObj = endDate ? new Date(endDate) : null;

    const filtered = data.filter((item) => {
      const itemPriority = item.priority.label;
      const itemLastUpdate = new Date(item.last_update.formatted);
      const itemGroup = item.group;
      const itemEmail = item.email;

      const priorityMatch = !priority || itemPriority === priority;
      const startDateMatch = !startDateObj || itemLastUpdate >= startDateObj;
      const endDateMatch = !endDateObj || itemLastUpdate <= endDateObj;
      const groupMatch = !group || itemGroup === group;
      const emailMatch = !email || itemEmail === email;

      return priorityMatch && startDateMatch && endDateMatch && groupMatch && emailMatch;
    });

    setFilteredData(filtered);
  };

  const handleLogout = async () => {
    try {
      await axios.post(myendpoint+'/login-social/logout', {}, {
        withCredentials: true,
      });
      navigate("/login"); // Utiliza navigate en lugar de window.location.href
    } catch (err) {
      console.error('Error al cerrar sesión', err);
    }
  };

  return (
    <>
      <Navbar onFilterChange={handleFilterChange} />
      <div className="cont">
        <div className="user-info">
          <p>Bienvenido, {auth.fullName}</p>
        </div>
      </div>
      {isLoading ? (
        <div className="loading-container">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      ) : error ? (
        <div className="error-container">
          <p>{error}</p>
        </div>
      ) : (
        <Routes>
          <Route path="/" element={<MainComponent filteredData={filteredData} />} />
          <Route path="/individual" element={<Individual filters={filters} />} />
        </Routes>
      )}
    </>
  );
};

const MainComponent = ({ filteredData }) => {
  const navigate = useNavigate();

  return (
    <main>
      <Board data={filteredData} />
      <button
        className="floating-button"
        onClick={() => navigate("/individual")}
        aria-label="Ir a Tickets cerrados"
      >
        Ir a Tickets cerrados ✅
      </button>
    </main>
  );
};

export default FirstPanel;
